:host {

    @include mix-for-sizes-down(phone) {
        display: flex;

        .ti-add-to-myti-list-btn {
            flex-grow: 1;
        }
    }

}
